import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
	tournaments: [],
	tournament: null,
	search: [],

	creating: false,
	deleting: false,
	updating: false,
	restoring: false,
	gettingList: false,
	gettingItem: false,
	searching: false,
  importing: false,

	isError: false,
	errorCode: 0,
	errorMessage: null,
};

export const TournamentSlice = createSlice({
	name: 'tournament',
	initialState,
	reducers: {

		clearTournamentList: (state, action) => {
			return { ...state, tournaments: [] };
		},

		clearTournamentItem: (state, action) => {
			return { ...state, tournament: null };
		},

		clearTournamentSearchResult: (state, action) => {
			return { ...state, search: [] };
		},

		onLoadCreate: (state, action ) => {
			return {...state, creating: true};
		},

		onLoadDelete: (state, action ) => {
			return {...state, deleting: true};
		},

		onLoadRestore: (state, action ) => {
			return {...state, restoring: true};
		},

		onLoadArchive: (state, action ) => {
			return {...state, deleting: true};
		},

		onLoadUpdate: (state, action ) => {
			return {...state, updating: true};
		},

		onLoadUpdateStatuses: (state, action ) => {
			return {...state, updating: true};
		},

		onLoadList: (state, action ) => {
			return {...state, gettingList: true};
		},

		onLoadItem: (state, action ) => {
			return {...state, gettingItem: true};
		},

		onLoadImport: (state, action ) => {
			return {...state, importing: true};
		},

		onLoadSearch: (state, action ) => {
			return {...state, search: [], searching: true};
		},

		// Success
		onSuccessCreate: (state, action) => {
			return {...state, creating: false};
		},

		onSuccessDelete: (state, action) => {
			return {...state, deleting: false};
		},

		onSuccessRestore: (state, action) => {
			return {...state, restoring: false};
		},

		onSuccessUpdate: (state, action) => {
			return {...state, updating: false};
		},

		onSuccessUpdateStatuses: (state, action) => {
			return {...state, updating: false};
		},

		onSuccessList: (state, action) => {
			return {...state, tournaments: action.payload.data, gettingList: false};
		},

		onSuccessItem: (state, action) => {
			return {...state, tournament: action.payload.data, gettingItem: false};
		},

		onSuccessSearch: (state, action) => {
			return {...state, search: action.payload.data, searching: false};
		},

		onSuccessImport: (state, action) => {
			return {...state, importing: false};
		},

		// Errors
		onFailCreate: (state, action) => {
			return {...state, creating: false };
		},
		onFailDelete: (state, action) => {
			return {...state, deleting: false };
		},
		onFailRestore: (state, action) => {
			return {...state, restoring: false };
		},
		onFailUpdate: (state, action) => {
			return {...state, updating: false };
		},
		onFailUpdateStatuses: (state, action) => {
			return {...state, updating: false };
		},
		onFailList: (state, action) => {
			return {...state, tournaments: [] };
		},
		onFailItem: (state, action) => {
			return {...state, tournament: null };
		},
		onFailSearch: (state, action) => {
			return { ...state, search: [], searching: false };
		},
		onFailImport: (state, action) => {
			return { ...state, importing: false };
		},
	},
});

export const {
	clearTournamentItem,
	clearTournamentList,
	clearTournamentSearchResult
} = TournamentSlice.actions;
